module.exports = __webpack_public_path__ + "static/Open AdStream-122ba32885564e4ca45a7ceae779f946.svg";